import { AnomalyFormData, AnomalyStatus } from './types';

// ============================================================================
// COLLECTION CONFIG
// ============================================================================

export const ANOMALY_COLLECTION_NAME = 'Anomaly Records';
export const ANOMALY_COLLECTION_USER_TYPE = 'anomaly_records';
export const ANOMALY_FILE_COLLECTION_NAME = 'Anomaly Summary Files';
export const ANOMALY_FILE_USER_TYPE = 'anomaly_summary_file';

// ============================================================================
// STATUS OPTIONS
// ============================================================================

export const ANOMALY_STATUSES: { value: AnomalyStatus; label: string; color: string }[] = [
  { value: 'NEW', label: 'New', color: '#e94560' },
  { value: 'ACKNOWLEDGED', label: 'Acknowledged', color: '#f39c12' },
  { value: 'INVESTIGATING', label: 'Investigating', color: '#3498db' },
  { value: 'RESOLVED', label: 'Resolved', color: '#2ecc71' },
  { value: 'DISMISSED', label: 'Dismissed', color: '#95a5a6' },
];

// ============================================================================
// EQUIPMENT TYPES
// ============================================================================

export const EQUIPMENT_TYPES = [
  { value: 'Hydronic Chiller', label: 'Hydronic Chiller' },
  { value: 'AHU', label: 'AHU (Air Handling Unit)' },
  { value: 'Boiler', label: 'Boiler' },
  { value: 'Pump', label: 'Pump' },
  { value: 'VAV', label: 'VAV (Variable Air Volume)' },
  { value: 'Other', label: 'Other' },
];

// ============================================================================
// METRIC PRESETS
// ============================================================================

export const METRIC_PRESETS = {
  'Hydronic Chiller': [
    { name: 'HC_Energy_kW', unit: 'kW', min: 8.5, max: 10 },
    { name: 'HC_LWT_F', unit: '°F', min: 42, max: 60 },
    { name: 'HC_EWT_F', unit: '°F', min: 60, max: 95 },
    { name: 'HC_LoopFlow_GPM', unit: 'GPM', min: 20, max: 36 },
    { name: 'HC_LoopSideEWT_F', unit: '°F', min: 75, max: 85 },
    { name: 'HC_LoopSideLWT_F', unit: '°F', min: 104, max: 118 },
    { name: 'HC_CompRuntimeHours', unit: 'hrs', min: 0, max: 10000 },
    { name: 'HC_CompStartsDaily', unit: 'starts', min: 8, max: 16 },
  ],
  'AHU': [
    { name: 'AHU_Energy_kW', unit: 'kW', min: 15, max: 25 },
    { name: 'AHU_SupplyAirTemp_F', unit: '°F', min: 82, max: 99 },
    { name: 'AHU_ReturnAirTemp_F', unit: '°F', min: 64, max: 72 },
    { name: 'AHU_SupplyAirRH_pct', unit: '%', min: 40, max: 60 },
    { name: 'AHU_ProcessAirflow_CFM', unit: 'CFM', min: 12355, max: 17650 },
    { name: 'AHU_ProcessFanRPM', unit: 'RPM', min: 900, max: 1450 },
    { name: 'AHU_ReactivationFanRPM', unit: 'RPM', min: 600, max: 1000 },
    { name: 'AHU_Water_GPH', unit: 'GPH', min: 100, max: 160 },
  ],
};

// ============================================================================
// FORM HELPERS
// ============================================================================

export function getEmptyAnomalyForm(): AnomalyFormData {
  return {
    equipmentSourceId: '',
    equipmentType: 'Hydronic Chiller',
    status: 'NEW',
    metricName: 'HC_Energy_kW',
    currentValue: 12.5,
    expectedMin: 8.5,
    expectedMax: 10,
    zScore: 2.5,
    direction: 'high',
    unit: 'kW',
    additionalMetrics: [],
  };
}

export function generateAnomalyId(): string {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 8);
  return `ANM-${timestamp}-${random}`.toUpperCase();
}


